<script lang="ts">
  import { afterNavigate } from '$app/navigation';
  import { profilePreview } from '$lib/stores/profilePreview';
  import MessageModal from '../reusable/messages/MessageModal.svelte';
  import UserProfileSlideOver from '../reusable/UserProfileSlideOver.svelte';

  const { isOpen, showMessageModal, profile } = profilePreview;

  afterNavigate(() => {
    profilePreview.reset();
  });
</script>

<UserProfileSlideOver
  bind:open={$isOpen}
  previewedUser={$profile}
  openMessageModal={() => profilePreview.openMessageModal()}
/>

{#if $profile}
  <MessageModal
    bind:showMessageModal={$showMessageModal}
    receiverId={Number($profile.profile.id)}
  />
{/if}
